<template>
<div class="page tableofcontents">
  <br>
  <p class="dustin preheader">
    Asset Class
  </p>
  <p class="dustin-title ">
    MBS
  </p>
  <br>
  <div class="columns is-centered">
    <div class="column is-half">
      <p class="description">
        Methodology
      </p>
      <p class="criteria">
        The extent of resource savings in aggregated amongst the rollup of MBS pools, using data from Fannie and Freddie Mac. Coverage is pertinent to the MBS issuances that have undergone green certification programs, which is 19% of your MBS portfolio. Using EPA conversion factors, this amount of resource savings over each year is equivalent to
      </p>
      <br>


      <nav class="level">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Fewer Airplanes</p>
            <p class="title">123</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Gallens of Water</p>
            <p class="title">456K</p>
          </div>
        </div>
        
      </nav>
    </div>
    <div class="column is-half">
      <div class="chart-container-small">
        <bar-chart class="chart-container-small" :chart-data="datacollection" :options="nolegend"></bar-chart>
      </div>
    </div>
  </div><!-- columns --> 
  <div class="columns">
    <div class="column is-one-third">
      <p class="title has-text-centered">
        41,000
        <span class="icon is-large">
          <img src="https://d1158lcjk2f3km.cloudfront.net/assets.00/asst4mz2woyq">
        </span>


      </p>
      <p class="subtitle is-6 has-text-centered">
        Families in Affordable Housing
      </p>
    </div>
    <div class="column is-two-thirds">
      <p class="description">
        Methodology
      </p>
      <p class="criteria">
        "Families in Affordable housing" is based on a combination of direct multi-family MBS disclosures from Fannie Mae and Freddie Mac, as well as leveraging regional demographic data about single-family MBS. Numbers are absolute, not compared to a bechmark.
      </p>
    </div>
  </div>
  <p class="preheader has-text-centered">Paris Climate Alignment</p>
  <div class="columns">
    <div class="column">
      <div class="bottomchart">
        <line-chart :options="bottomGraph" :chart-data="slrdata" ></line-chart>
      </div>
    </div>
    <div class="column is-narrow is-one-quarter">
      <p class="description">
        Methodology
      </p>
      <p class="criteria">
        Implied Temperature Rise (ITR) is a forward-looking estimation of the temperature rise associated with an asset. Here, calculations are made by combining measured energy efficiency ratings within MBS issuances where reported, and estimated energy efficiencies per building area based on average building energy use.
      </p>
    </div>
  </div><!-- columns -->
  
    
  
  
<!-- page-->
  
</div>
</template>

<script>

 import BarChart from './subcomponents/BarChart.js'
 import DoughnutChart from './subcomponents/DoughnutChart.js'
 import LineChart from './subcomponents/LineChart.js'

  export default {
    components: {
      BarChart, LineChart
    },
    data () {
      return {
        datacollection: {},
        slrdata: {},
        bottomGraph: {},
        nolegend: {}
      }
    },
    mounted () {
      this.fillData(),
      console.log(this.datacollection)
    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: ['Water Saved', 'COO2e Saved'],
          datasets: [
            {
              backgroundColor: ['grey', 'green'],
              data: [34, 45]
            }, 
          ]
        },
        this.slrdata = {
          labels: [2020, 2050],
          datasets: [
            {
              label: 'Implied Temprature Rise (ITR)',
              backgroundColor: '#f87979',
              data: [.13, 2.0]
            }
          ]
        },
        this.nolegend = {
          maintainAspectRatio: false,
          legend: { display: false },
        },
        this.bottomGraph = {
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
    },
  }

</script>

<style lang="css" scoped>
  .tableofcontents {
    padding: 6rem;
  }
  .chart-container-small {
    position: relative;
    height: 200px;
    width: 300px;
  }
  .bottomchart {
    height: 800px;
    width: 500px;
  }


</style>
